// src/pages/Sales/SalesPage.tsx
import { Link } from "react-router-dom";
//import SocketStatus from "@/components/Debug/SocketStatus";

export const SalesPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Sales Portal</h1>

      <p className="mb-4 text-muted-foreground">
        Welcome to the Sales portal. From here you can manage leads, contracts,
        and start live broadcasts.
      </p>

      <Link
        to="/sales/broadcast"
        className="inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
      >
        Go to Broadcast Panel
      </Link>

      {/* 🔍 Debug socket connection */}
      {/* <SocketStatus /> */}
    </div>
  );
};

export default SalesPage;
